/* eslint-disable no-useless-concat */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { useAuthContext } from '../../../../context/auth.context'
import { useDashboardContext } from '../../../../context/dashboard.context'
import { dashboardConst } from '../../../../utils/action.constant'
import {
  useLoadAssetChannels,
  useLoadSIPPayoutWidgets,
  useLoadDynamicPayoutAssetReportees,
  useLoadDynamicPayoutAssetManager,
  useLoadSIPWidgetsAccountDetails
} from '../../../../hooks/dashboard.hooks'
import {
  Box,
  Divider,
  Flex,
  Icon,
  Skeleton,
  Stack,
  Text,
  VStack,
  Tooltip
} from '@chakra-ui/react'
import DrillDownTable, {
  TH,
  TR,
  TD,
} from '../../../../components/dashboard-table'
import ReactExport from 'react-data-export'
import { BiDownload } from 'react-icons/bi'
import { isRoleAccount, isRoleSelf } from '../../../../config/roles.config'
import { calculateStartEndDate } from '../../../../utils/dashboard.utils'
import { sectionDetailedTrack } from '../../../repository/repo.utils'
import { GA_CATEGORY_DASHBOARD } from './../../../repository/repo.utils'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

function WidgetSIPDynamic2View() {
  const {
    state: { queryFilters, sipReporteeList, activeFilterOption},    
    dispatch: dashboardDispatch,
  } = useDashboardContext()
  const {
    state: { authData },
  } = useAuthContext()
  const [download, setDownload] = useState(false)
  const {
    mutate: mutateLoadReportees,
    data: reporteeList,
    isLoading : isReporteesLoading,
    isSuccess : isReporteesSuccess
  } = useLoadDynamicPayoutAssetReportees()


  const {
    mutate: mutateLoadChannel,
    data: channelList,
    isLoading: isChannelLoading,
  } = useLoadAssetChannels()

  const { 
    mutate: mutateLoadManagerDetailsData,
    data: managerDetails,
    isLoading : isManagerLoading,
    isSuccess : isManagerSuccess
  } = useLoadDynamicPayoutAssetManager()

  const {
    mutate: mutateLoadSIPWidget,
    data: sipWidgetList,
    isLoading: isReporteesSipKpiLoading,
    isSuccess: isReporteesSipKpiSuccess,
  } = useLoadSIPPayoutWidgets()

  
  const {
    mutate: mutateLoadManagerTargets,
    data: sipWidgetManagerTargetList,
    isLoading: isManagerSipKpiLoading,
    isSuccess: isManagerSipKpiSuccess,
  } = useLoadSIPPayoutWidgets()

  const {
    mutate: mutateLoadAccountDetails,
    data: sipWidgetAccountDetails,
    isLoading: isAccountDetailsLoading,
    isSuccess: isAccountDetailsSuccess,
  } = useLoadSIPWidgetsAccountDetails()


  const [isSelf, setIsSelf] = useState(true)
  const [isAccountManager, setIsAccountManager] = useState(false)

  useEffect(() => {
    return () => {
      dashboardDispatch({
        type: dashboardConst.REMOVE_SIP_RESOURCE,
      })
    }
  }, [])

  useEffect(() => {
    let reportee = {}
    if (queryFilters?.selectedCreator?.label === 'All') {
      queryFilters.selectedCreator = { ...authData, label: authData.operating_asset_first_name  }
      reportee = {...queryFilters.selectedCreator}
    } else {
      clearReporteeToStack()
    }
    if (reportee?.asset_id) {
      addReportee()
      addReporteeToStack(reportee, true)
    }
  }, [queryFilters.selectedCreator])

  const addReportee = data => {
    dashboardDispatch({
      type: dashboardConst.ADD_REPORTEES,
      payload: data,
    })
  }
  const clearReporteeToStack = () => {
    dashboardDispatch({
      type: dashboardConst.CLEAR_REPORTEE_STACK,
    })
  }

  useEffect(() => {
    checkUserRole()
  }, [queryFilters.selectedCreator,
    queryFilters.selectedPeriod,
    queryFilters.selectedPeriodType,
    queryFilters.selectedSipSegment,
    queryFilters.selectedYear])

  const checkUserRole = (manager_id = false) => {
    const { asset_type_id,asset_id,operating_asset_first_name } = authData

    if (isRoleAccount.includes(manager_id ? manager_id : asset_type_id)) {
      setIsAccountManager(true)
    } else {
      if (isRoleSelf.includes(asset_type_id)) {
        setIsSelf(false)
      }
    }
    let manager = {}
    if (
      !!queryFilters &&
      queryFilters.hasOwnProperty('selectedCreator') &&
      queryFilters.selectedCreator?.value !== 0
    ) {
      manager = {
        operating_asset_first_name:
          queryFilters.selectedCreator?.operating_asset_first_name,
        asset_id: queryFilters.selectedCreator?.asset_id,
        label:queryFilters.selectedCreator?.operating_asset_first_name,
      }
    } else {
    // queryFilters.defaultCreator = {label: authData.operating_asset_first_name, asset_id : authData.asset_id}
      manager = {
        operating_asset_first_name,
        asset_id,
    }
  }
    // if (isAccountManager) {
    //   loadAccountForAsset(manager)
    // } else {
    
    loadResourceForAsset(manager) 
    loadManagerTargets(manager)
    loadSIPWidgetsAccountDetails(manager)
  // }
  }

  const loadManagerTargets = manager => {
    const {
      selectedPeriodType,
      selectedPeriod,
      selectedSipSegment,
      selectedYear,
    } = queryFilters

    
    mutateLoadManagerTargets({
      creator: manager,
      segment: selectedSipSegment,
      timeline: selectedPeriodType,
      period: selectedPeriod,
      year: selectedYear,
      flag: 1,
      is_sip_dynamic_payout: 1
    })
  }

  const loadAccountForAsset = manager => {
    const {
      selectedPeriodType,
      selectedPeriod,
      selectedSipSegment,
      selectedYear,
    } = queryFilters
    let { startDate, endDate } = calculateStartEndDate({
      selectedPeriod,
      selectedPeriodType,
      selectedYear,
    })
    mutateLoadChannel(
      {
        segment: selectedSipSegment,
        manager,
        startDate,
        endDate,
      },
      {
        onSuccess: data => {
          if (data.length) {
            loadSIPWidgetForAsset(manager)
          }
        },
      }
    )
  }

  const loadResourceForAsset = (asset, isManager = false) => {
    const reportee = asset
    const {
      selectedSipSegment,
      selectedPeriodType,
      selectedPeriod,
      selectedYear,
    } = queryFilters
    let { startDate, endDate, startYear } = calculateStartEndDate({
      selectedPeriod,
      selectedPeriodType,
      selectedYear,
    })
    mutateLoadReportees(
      { 
         flag: 10,
         creator: reportee,
         timeline_id: !!selectedPeriodType ? selectedPeriodType.value : 1,
         year: !!selectedYear ? selectedYear.value.replaceAll(' ','') : '',
         periodTypeId: !!selectedPeriod ? selectedPeriod.value : 1,
         segment: !!selectedSipSegment ? selectedSipSegment.value : 0,
         startDate,
         endDate
         },
      {
        onSuccess: data => {
          addReporteeToStack(reportee, isManager)
          if (data.length) {
            loadSIPWidgetForAsset(reportee)
          }
        },
      }
    )
    
    loadSelfData(reportee.asset_id)
    loadManagerTargets(reportee)
  }

  const loadSelfData = manager_id => {
    const {
      selectedPeriodType,
      selectedPeriod,
      selectedSipSegment,
      selectedYear,
    } = queryFilters
    mutateLoadManagerDetailsData(
      { 
      manager_id: manager_id,
      timeline_id: !!selectedPeriodType ? selectedPeriodType.value : 1,
      year: !!selectedYear ? selectedYear.value.replaceAll(' ','') : '',
      period: !!selectedPeriod ? selectedPeriod.value : 1,
      segment: !!selectedSipSegment ? selectedSipSegment.value : 0

    })
  }

  const loadSIPWidgetForAsset = (reportee, isAccount = false) => {
    const {
      selectedPeriodType,
      selectedPeriod,
      selectedSipSegment,
      selectedYear,
    } = queryFilters
    let { startDate, endDate, startYear } = calculateStartEndDate({
      selectedPeriod,
      selectedPeriodType,
      selectedYear,
    })

    mutateLoadSIPWidget({
      creator: reportee,
      segment: selectedSipSegment,
      timeline: selectedPeriodType,
      period: selectedPeriod,
      year: selectedYear,
      isManagerTarget: false,
      flag: 0,
      is_sip_dynamic_payout: 1,
      startDate,
      endDate,
    })
  }
  
  const loadSIPWidgetsAccountDetails = (reportee)=>{
    const {
      selectedPeriodType,
      selectedPeriod,
      selectedSipSegment,
      selectedYear,
    } = queryFilters

    mutateLoadAccountDetails({
      creator: reportee,
      segment: selectedSipSegment,
      timeline: selectedPeriodType,
      period: selectedPeriod,
      year: selectedYear,
      flag: 0,
      is_sip_dynamic_payout: 1,
    })
  }

  const addReporteeToStack = (reportee, isManager) => {
    dashboardDispatch({
      type: isManager
        ? dashboardConst.ADD_SIP_RESOURCE
        : dashboardConst.SET_SIP_RESOURCE,
      reportee: reportee,
    })
  }

  const renderSelfHeadings = () =>{
    let KpiCodes = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0] && !!sipWidgetManagerTargetList[0].header ? sipWidgetManagerTargetList[0].header : []
    let heads = ['Employee Name',
    'Employee Code',
    'Employee Email',
      'Role',
      'Segment',
     ...(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0) ? [
      'Circle','Cluster'
      ] : []),
      ...(!!queryFilters && (queryFilters.selectedSipSegment.value === 358 || queryFilters.selectedSipSegment.value === 0) ? [
        'Vertical'
        ] : []),
...(Object.entries(KpiCodes).length > 0 ?
      ['Employees on SIP',
      'Qualified for SIP',
      'Summarized SIP Penetration %',
      'Summarized SIP Utilization %',
      `Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`] : [])
  ]

  let individualHeads =['On Target Payout (Default)',
 'Individual OverAll Weighted % for MTD',
  'Individual OverAll Weighted % for QTD',
  'Individual OverAll Weighted % for YTD',
'Individual Final Payout Amount',
'Individual Final Payout %']

  individualHeads = !!queryFilters.selectedSipSegment && queryFilters.selectedSipSegment.value === 184 ? 
  individualHeads.filter(el => el !=='Individual OverAll Weighted % for YTD') : queryFilters.selectedSipSegment && (queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 358) ?
  individualHeads.filter(el => el !=='Individual OverAll Weighted % for MTD') : individualHeads

 
  let filteredKpiCodes = Object.entries(KpiCodes)?.map((header, i) => {
    const [key, value]  = header
    let removeHeads = Object.entries(value).filter(([key]) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','widget_type_name','widget_type_code_sequence_id'].includes(key))
  return Object.fromEntries(removeHeads)
    })  
  let subHeads = []
  
  let dynamicHeads = !!KpiCodes && 
  Object.entries(KpiCodes).map((header, i) => {
      let isParentKpi = false
      let toolTipName  = ''
         const [key, value]  = header
        isParentKpi = value['is_parent_kpi']
        toolTipName = value['widget_type_name']
        subHeads = Object.entries(value).filter(([key]) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','is_parent_kpi','widget_type_name','widget_type_code_sequence_id'].includes(key))
        return (
        <TH rowSpan={1} classes={isParentKpi ? `parent-column-Theme`: `green-theme`}  justify={"center"} colSpan={subHeads.length} key={i + 1}>
          <Tooltip
                  label={toolTipName}
                  fontSize="sm"
                  bg="secondary"
                  color="black.700"
                ><span> {value.widget_type_measurement_unit !== 'INR' ? `${key} ( ${value.widget_type_measurement_unit}; Value In - ${value.widget_type_measurement_name} )` : `${key} (Value In - ${value.widget_type_measurement_name})`}
        </span>
        </Tooltip>
        </TH>
      )
    })


    heads = heads.map(item => (
      <TH rowSpan={2} key={item}>
        {item}
      </TH>
    ))
    individualHeads = individualHeads.map(item => (
      <TH rowSpan={2} key={item}>
        {item}
      </TH>
    ))
    heads = heads.concat(dynamicHeads)
    if(Object.entries(KpiCodes).length > 0){
    heads = heads.concat(individualHeads)
    }
    let tableHead = (
      <>
        <TR>
          <TH rowSpan={2}>#</TH>
          {heads}
        </TR>
        <TR>
          {!!dynamicHeads && dynamicHeads.length>0 &&
           filteredKpiCodes?.map((kpi) => (
              Object.values(kpi).filter(el=> el!== 0 && el!== 1).map((key,i) =>
              <TH rowSpan={1} classes={kpi['is_parent_kpi'] === 1 ? `parent-column-Theme` : `green-theme`} key={key}>
                {key}
              </TH>
            ))
            )
          }
        </TR>
      </>
    )
    return tableHead
  }
  
  const renderHeadings = (isSelf = false) => {
    let KpiCodes = !!sipWidgetList && !!sipWidgetList[0] && !!sipWidgetList[0].header ? sipWidgetList[0].header : []
    let heads = [
      isSelf
        ? 'Self'
        : isAccountManager
        ? !!queryFilters.selectedSipSegment &&
          queryFilters.selectedSipSegment.value === 184
          ? 'Channel Name'
          : 'Account Name'
        : 'Employee Name',
      isAccountManager
        ? !!queryFilters.selectedSipSegment &&
          queryFilters.selectedSipSegment.value === 184
          ? 'Channel Code'
          : 'Account Code'
        : 'Employee Code',
      'Employee Email',
      'Role',
      'Segment',
      ...(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0) ? [
        'Circle','Cluster'
        ] : []),
        ...(!!queryFilters && (queryFilters.selectedSipSegment.value === 358 || queryFilters.selectedSipSegment.value === 0) ? [
          'Vertical'
          ] : []),
          ...(Object.entries(KpiCodes).length > 0 ?
      ['Employees on SIP',
      'Qualified for SIP',
      'Summarized SIP Penetration %',
      'Summarized SIP Utilization %',
      `Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`] : [])
    ]
    let individualHeads = ['On Target Payout (Default)',
      'Individual OverAll Weighted % for MTD',
      'Individual OverAll Weighted % for QTD',
      'Individual OverAll Weighted % for YTD',
      'Individual Final Payout Amount',
      'Individual Final Payout %']

  individualHeads = !!queryFilters.selectedSipSegment && queryFilters.selectedSipSegment.value === 184 ? 
  individualHeads.filter(el => el !=='Individual OverAll Weighted % for YTD') : queryFilters.selectedSipSegment && (queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 358) ?
  individualHeads.filter(el => el !=='Individual OverAll Weighted % for MTD') : individualHeads



let filteredKpiCodes = Object.entries(KpiCodes)?.map((header, i) => {
    const [key, value]  = header
    let removeHeads = Object.entries(value).filter(([key]) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','widget_type_name','widget_type_code_sequence_id'].includes(key))
  return Object.fromEntries(removeHeads)
    })  
  let subHeads = []
  let isParentKpi = false
  let toolTipName = ''
  let dynamicHeads = !!KpiCodes && 
  Object.entries(KpiCodes).map((header, i) => {
        const [key, value]  = header
        isParentKpi = value['is_parent_kpi']
        toolTipName = value['widget_type_name']
        subHeads = Object.entries(value).filter(([key]) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','is_parent_kpi','widget_type_name','widget_type_code_sequence_id'].includes(key))
        return (
        <TH rowSpan={1} classes={isParentKpi ? `parent-column-Theme`: `green-theme`} justify={"center"} colSpan={subHeads.length} key={i + 1}>
           <Tooltip
                  label={toolTipName}
                  fontSize="sm"
                  bg="secondary"
                  color="black.700"
                ><span> {value.widget_type_measurement_unit !== 'INR' ? `${key} ( ${value.widget_type_measurement_unit}; Value In - ${value.widget_type_measurement_name} )` : `${key} (Value In - ${value.widget_type_measurement_name})`}
        </span>
        </Tooltip>
        </TH>
      )
    })
   
    heads = heads.map(item => (
      <TH rowSpan={2} key={item}>
        {item}
      </TH>
    ))
    individualHeads = individualHeads.map(item => (
      <TH rowSpan={2} key={item}>
        {item}
      </TH>
    ))
    heads = heads.concat(dynamicHeads)
    if(Object.entries(KpiCodes).length > 0){
    heads = heads.concat(individualHeads)
    }
    let tableHead = (
      <>
        <TR>
          <TH rowSpan={2}>#</TH>
          {heads}
        </TR>
        <TR>
        {!!dynamicHeads && dynamicHeads.length>0 &&
           filteredKpiCodes?.map((kpi) => (
            Object.values(kpi).filter(el=> el!== 0 && el!== 1).map((key,i) =>
              <TH rowSpan={1} classes={kpi['is_parent_kpi'] === 1 ? `parent-column-Theme` : `green-theme`} key={key}>
                {key}
              </TH>
            )))
          }
        </TR>
      </>
    )
    return tableHead
  }

    
  const getColumnHeader = (widget_type_code, key, self = false) => {
    let kpiCodeHeaders
    if (!self) {
      kpiCodeHeaders = !!sipWidgetList && !!sipWidgetList[0] && !!sipWidgetList[0].header ? sipWidgetList[0].header : []
    }
    else {
      kpiCodeHeaders = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0] && !!sipWidgetManagerTargetList[0].header ? sipWidgetManagerTargetList[0].header : []
    }
    let headers = kpiCodeHeaders[widget_type_code]
    let columnnName = headers[key]
    return columnnName
  }


 
 
  const setManagerKpiResponseBody = () => {
    let bodyResponseData,headerResponseData, assetList
       bodyResponseData = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0]?.body ? sipWidgetManagerTargetList[0].body : []
       headerResponseData = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0]?.header ? sipWidgetManagerTargetList[0].header : []
       assetList = managerDetails?.map(el => el.asset_id + "::" + el.workforce_tag_id)
    
    let kpiCodes = !!headerResponseData && Object.keys(headerResponseData)
    let kpiCodeWiseHeaders = getKpiCodeWiseHeaders(true)
    let userMap = new Map();
    let userKPICodeData = new Map();
    let newKpiCodeNameMap = new Map()
    
    for(let index in bodyResponseData) {
         userKPICodeData = bodyResponseData[index];
    let asset_id = userKPICodeData.asset_id + "::" + userKPICodeData.workforce_tag_id;
    newKpiCodeNameMap.set(userKPICodeData.widget_type_code,userKPICodeData.widget_type_name)
    let kpiCode = userKPICodeData.widget_type_code;
    
        if(userMap.has(asset_id)) {
            let kpiCodeMap = userMap.get(asset_id);
            if(!kpiCodeMap.has(kpiCode)) {
                kpiCodeMap.set(kpiCode, userKPICodeData);
            }
        } else {
            let kpiCodeMap = new Map();
            kpiCodeMap.set(kpiCode, userKPICodeData);
            userMap.set(asset_id, kpiCodeMap);
        }
    }

    let userWiseFinalExcelDataMap = new Map();
    let nonKpiCodeArray = []
    
    
   
    userMap.forEach((value, asset_id) => {
        let columnExcelDataArray = [];
        for(let index in kpiCodes) {
            let kpiCode = kpiCodes[index];
            let kpiCoderHeaderData = headerResponseData[kpiCode];
            let kpiCodeHeders = kpiCodeWiseHeaders[kpiCode];
            let userKPICodeDataMap = userMap.get(asset_id);
            let userDetails = userKPICodeDataMap.get(kpiCode);
            //console.log("key", userDetails , kpiCodeHeders);
            if(userDetails!== undefined && kpiCodeHeders!==undefined) {
                for(let userDetailsKey of kpiCodeHeders) {
                    let excelKey =  headerResponseData[kpiCode].widget_type_name + "_" + kpiCoderHeaderData[userDetailsKey];
                 //   console.log(excelKey)
                    let obj = {};
                    obj[excelKey] = userDetails[userDetailsKey];
                    columnExcelDataArray.push(obj);
                     obj = {};
                    obj[excelKey] = "NA";
                    nonKpiCodeArray.push(obj)
                }
            } else {
                for(let userDetailsKey of kpiCodeHeders) {
                    let excelKey = headerResponseData[kpiCode].widget_type_name + "_" + kpiCoderHeaderData[userDetailsKey];
                    let obj = {};
                    obj[excelKey] = "NA";
                    nonKpiCodeArray.push(obj)
                    columnExcelDataArray.push(obj);
                }
            }
        }

        return (userWiseFinalExcelDataMap.set(asset_id, columnExcelDataArray))
        
    })
    assetList.forEach((asset_id) =>{
      console.log("asset_id",asset_id ,kpiCodes)
      if(!userMap.has(asset_id)){
        userWiseFinalExcelDataMap.set(asset_id,nonKpiCodeArray)
      }

    })

    return userWiseFinalExcelDataMap
  }
 
  const setReporteeKpiResponseBody = () => {
    let bodyResponseData,headerResponseData, assetList
       bodyResponseData = !!sipWidgetList && !!sipWidgetList[0]?.body ? sipWidgetList[0].body : []
       headerResponseData = !!sipWidgetList && !!sipWidgetList[0]?.header ? sipWidgetList[0].header : []
       assetList = reporteeList?.map(el => el.asset_id)
    
    let kpiCodes = !!headerResponseData && Object.keys(headerResponseData)
    let kpiCodeWiseHeaders = getKpiCodeWiseHeaders()
    let userMap = new Map();
    let userKPICodeData = new Map();
    let newKpiCodeNameMap = new Map()
    
    for(let index in bodyResponseData) {
         userKPICodeData = bodyResponseData[index];
    let asset_id = userKPICodeData.asset_id;
    newKpiCodeNameMap.set(userKPICodeData.widget_type_code,userKPICodeData.widget_type_name)
    let kpiCode = userKPICodeData.widget_type_code;
    
        if(userMap.has(asset_id)) {
            let kpiCodeMap = userMap.get(asset_id);
            if(!kpiCodeMap.has(kpiCode)) {
                kpiCodeMap.set(kpiCode, userKPICodeData);
            }
        } else {
            let kpiCodeMap = new Map();
            kpiCodeMap.set(kpiCode, userKPICodeData);
            userMap.set(asset_id, kpiCodeMap);
        }
    }

    let userWiseFinalExcelDataMap = new Map();
    let nonKpiCodeArray = []
    
    
   
    userMap.forEach((value, asset_id) => {
        let columnExcelDataArray = [];
        for(let index in kpiCodes) {
            let kpiCode = kpiCodes[index];
            let kpiCoderHeaderData = headerResponseData[kpiCode];
            let kpiCodeHeders = kpiCodeWiseHeaders[kpiCode];
            let userKPICodeDataMap = userMap.get(asset_id);
            let userDetails = userKPICodeDataMap.get(kpiCode);
            //console.log("key", userDetails , kpiCodeHeders);
            if(userDetails!== undefined && kpiCodeHeders!==undefined) {
                for(let userDetailsKey of kpiCodeHeders) {
                    let excelKey =  headerResponseData[kpiCode].widget_type_name + "_" + kpiCoderHeaderData[userDetailsKey];
                 //   console.log(excelKey)
                    let obj = {};
                    obj[excelKey] = userDetails[userDetailsKey];
                    columnExcelDataArray.push(obj);
                     obj = {};
                    obj[excelKey] = "NA";
                    nonKpiCodeArray.push(obj)
                }
            } else {
                for(let userDetailsKey of kpiCodeHeders) {
                    let excelKey = headerResponseData[kpiCode].widget_type_name + "_" + kpiCoderHeaderData[userDetailsKey];
                    let obj = {};
                    obj[excelKey] = "NA";
                    nonKpiCodeArray.push(obj)
                    columnExcelDataArray.push(obj);
                }
            }
        }

        return (userWiseFinalExcelDataMap.set(asset_id, columnExcelDataArray))
        
    })
    assetList.forEach((asset_id) =>{
      if(!userMap.has(asset_id)){
        userWiseFinalExcelDataMap.set(asset_id,nonKpiCodeArray)
      }

    })

    return userWiseFinalExcelDataMap
  }

const getKpiCodeWiseHeaders = (isSelf = false) => {
  let response = {}
  let subHeads = []
  if(!isSelf){
  let reporteeKpiHeaders = !!sipWidgetList && !!sipWidgetList[0]?.header ? sipWidgetList[0].header : []
  Object.entries(reporteeKpiHeaders).map((header, i) => {
    const [key, value]  = header
    subHeads = Object.keys(value).filter((el) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','is_parent_kpi','widget_type_name','widget_type_code_sequence_id'].includes(el))
  response[key]= Object.values(subHeads)
  })
}
else {
  let managerKpiHeaders = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0]?.header ? sipWidgetManagerTargetList[0].header : []
  Object.entries(managerKpiHeaders).map((header, i) => {
    const [key, value]  = header
    subHeads = Object.keys(value).filter((el) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','is_parent_kpi','widget_type_name','widget_type_code_sequence_id'].includes(el))
  response[key]= Object.values(subHeads)
  })
}
  return response
}

const getAccountCodewiseHeaders = ()=>{
  let response = {}
  let subHeads = []
  let accountKpiHeaders = !!sipWidgetAccountDetails && !!sipWidgetAccountDetails[0]?.header ? sipWidgetAccountDetails[0].header : []
  Object.entries(accountKpiHeaders).map((header, i) => {
    const [key, value]  = header
    subHeads = Object.keys(value).filter((el) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','is_parent_kpi','widget_type_name','widget_type_code_sequence_id',
  'customer_account_code','customer_account_name'].includes(el))
  response[key]= Object.values(subHeads)
  })
  return response
}


const setAccountKpiResponseBody = () => {
    let bodyResponseData = !!sipWidgetAccountDetails && !!sipWidgetAccountDetails[0]?.body ? sipWidgetAccountDetails[0].body : []
    let headerResponseData = !!sipWidgetAccountDetails && !!sipWidgetAccountDetails[0]?.header ? sipWidgetAccountDetails[0].header : []
    let kpiCodes = Object.keys(headerResponseData)
    let kpiCodeWiseHeaders = getAccountCodewiseHeaders()
    let userMap = new Map();
    let userKPICodeData = new Map();
    
    for(let index in bodyResponseData) {
         userKPICodeData = bodyResponseData[index];
    let customer_account_code = userKPICodeData.customer_account_code + "::" + userKPICodeData.workforce_tag_name;
    let kpiCode = userKPICodeData.widget_type_code;
    
        if(userMap.has(customer_account_code)) {
            let kpiCodeMap = userMap.get(customer_account_code);
            if(!kpiCodeMap.has(kpiCode)) {
                kpiCodeMap.set(kpiCode, userKPICodeData);
            }
        } else {
            let kpiCodeMap = new Map();
            kpiCodeMap.set(kpiCode, userKPICodeData);
            userMap.set(customer_account_code, kpiCodeMap);
        }
    }
    //let userWiseFinalDataMap = new Map();
    let userWiseFinalExcelDataMap = new Map();
    userMap.forEach((value, customer_account_code) => {
        let columnDataArray = [];
        let columnExcelDataArray = [];
        for(let index in kpiCodes) {
            let kpiCode = kpiCodes[index];
            let kpiCoderHeaderData = headerResponseData[kpiCode];
            let kpiCodeHeders = kpiCodeWiseHeaders[kpiCode];
           // console.log("key", headerResponseData[kpiCode].widget_type_name);
            let userKPICodeDataMap = userMap.get(customer_account_code);
            let userDetails = userKPICodeDataMap.get(kpiCode);
            if(userDetails!== undefined && kpiCodeHeders!==undefined) {
                for(let userDetailsKey of kpiCodeHeders) {
                    let excelKey =  headerResponseData[kpiCode].widget_type_name + "_" + kpiCoderHeaderData[userDetailsKey];
                 //   console.log(excelKey)
                    let obj = {};
                    obj[excelKey] = userDetails[userDetailsKey];
                    columnExcelDataArray.push(obj);
                    columnDataArray.push(userDetails[userDetailsKey]);
                }
            } else {
                for(let userDetailsKey of kpiCodeHeders) {
                    let excelKey = headerResponseData[kpiCode].widget_type_name + "_" + kpiCoderHeaderData[userDetailsKey];
                    let obj = {};
                    obj[excelKey] = "NA";
                    columnExcelDataArray.push(obj);
                    columnDataArray.push("NA");
                }
            }
        }
        // else
        // return userWiseFinalDataMap.set(customer_account_code, columnDataArray);
        return (userWiseFinalExcelDataMap.set(customer_account_code, columnExcelDataArray))
        
    })

    return userWiseFinalExcelDataMap
  }


  const makeTableData = () => {
    let data = []
    
    let _arr = reporteeList || []
    let reporteeKpiHeaders = !!sipWidgetList && !!sipWidgetList[0]?.header ? sipWidgetList[0].header : []
    let reporteesSubHeadData = setReporteeKpiResponseBody()

    let parentHead = Object.values(reporteesSubHeadData)
    _arr?.forEach((item, i) => {
      let obj = {}
      obj['s.no'] = i + 1
      obj['Employee Name'] = item.operating_asset_first_name
      obj['Employee Code'] = item.operating_asset_customer_unique_id
      obj['Employee Email'] = !isAccountManager
        ? item.operating_asset_email_id
        : '-'
      obj['Role'] = !isAccountManager ? item.asset_type_name : '-'
      obj['Segment'] = !isAccountManager ? item.workforce_tag_name : '-'
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0)){
      obj['Circle'] = !isAccountManager ? item.account_name : '-'
      obj['Cluster'] = !isAccountManager ? item.cluster_tag_name : '-'
      }
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 358 || queryFilters.selectedSipSegment.value === 0)){
      obj['Vertical'] = !isAccountManager ? item.asset_vertical_name : '-'
      }
      if(!!reporteeKpiHeaders && Object.entries(reporteeKpiHeaders).length > 0){
      obj['Employees on SIP']= !!item.employees_on_sip ? item.employees_on_sip : '1'
      obj['Qualified for SIP']= !!item.qualified_for_sip ? item.qualified_for_sip : '1'
      obj['Summarized SIP Penetration %']= !!item.percentage_penetration ? item.percentage_penetration.toFixed(2) + '%' : '-'
      obj['Summarized SIP Utilization %']=  !!item.summary_utilization ? item.summary_utilization.toFixed(2) + '%' : '-'
      if(!!queryFilters && queryFilters.selectedPeriodType.value === 'QTD'){
      obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_qtd ? item.summary_weighted_sip_target_vs_achievement_qtd.toFixed(2) + ' %' :'-'
      }
      else if(!!queryFilters && queryFilters.selectedPeriodType.value === 'MTD'){
        obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_mtd ? item.summary_weighted_sip_target_vs_achievement_mtd.toFixed(2) + ' %' :'-'
      }
      else if(!!queryFilters && queryFilters.selectedPeriodType.value === 'YTD'){
        obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_ytd ? item.summary_weighted_sip_target_vs_achievement_ytd.toFixed(2) + ' %' :'-'
      }
      else{
        obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_ytd ? item.summary_weighted_sip_target_vs_achievement_ytd.toFixed(2) + ' %' :'-'
      }
     
      let kpiCodeHead = !!parentHead && parentHead.length>0  ? 
      parentHead?.filter(el =>  item.asset_id === el.asset_id)
      : []

      let reporteeKpiData = !!reporteesSubHeadData.get(item.asset_id) ? Array.from(reporteesSubHeadData.get(item.asset_id)) : []
      
       
        let reporteePredictionValues = !!reporteeKpiData && reporteeKpiData.length > 0 ? Object.assign(...reporteeKpiData) : {}
      obj =  {...obj, ...reporteePredictionValues}
       
      obj['On Target Payout (Default)']= (!!item.payout_target && item.payout_target.toFixed(2)) || 0
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 0)){
      obj['Individual OverAll Weighted % for MTD']= (!!item.overall_ach_mtd && item.overall_ach_mtd.toFixed(2) + ' %') || '0.00 %'
      }
      obj['Individual OverAll Weighted % for QTD']= (!!item.overall_ach_qtd && item.overall_ach_qtd.toFixed(2) + ' %') || '0.00 %'
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0 || queryFilters.selectedSipSegment.value === 358)){
      obj['Individual OverAll Weighted % for YTD']= (!!item.overall_ach_ytd && item.overall_ach_ytd.toFixed(2) + ' %') || '0.00 %'
      }
      obj['Individual Final Payout Amount']= (!!item.final_payout_amount && item.final_payout_amount.toFixed(2)) || 0
      obj['Individual Final Payout %']= (!!item.final_payout_percentage && item.final_payout_percentage.toFixed(2) + ' %') || '0.00 %'

    }
      if (isAccountManager) {
        ;[9, 10, 11, 12, 13, 14].forEach(x => {
          obj[x] = '-'
        })
      }

      data.push(obj)
    })
    return [data, _arr]
  }

  const renderData = () => {
    let [data, _arr] = makeTableData()
    return !!data && data.map((item, i) => (
      <TR key={i} >
        {Object.values(item).map((val, j) =>
          j === 1 ? (
            <TD
              key={j}
              onClickHandler={() => {
                _arr[i].label=_arr[i].operating_asset_first_name
                dashboardDispatch({
                type:dashboardConst.ADD_ACTIVE_FILTER_OPTION,
                activeFilterOption:_arr[i]
              })
                loadResourceForAsset(_arr[i])
              }}
              classes={`text-bold green-theme cursor-pointer`}
            >
              {val}
            </TD>
          ) : (
            <TD key={j}>{val}</TD>
          )
        )}
      </TR>
    ))
  }

  const renderAccountData = () => {
    let [data, _arr] = makeAccountData()
    return !!data && data.map((item, i) => (
      <TR key={i} >
        {Object.values(item).map((val, j) =>
          // j === 1 ? (
          //   <TD
          //     key={j}
          //     onClickHandler={() => {
          //       _arr[i].label=_arr[i].operating_asset_first_name
          //       dashboardDispatch({
          //       type:dashboardConst.ADD_ACTIVE_FILTER_OPTION,
          //       activeFilterOption:_arr[i]
          //     })
          //       loadResourceForAsset(_arr[i])
          //     }}
          //     classes={`text-bold green-theme cursor-pointer`}
          //   >
          //     {val}
          //   </TD>
          // ) : 
          (
            <TD key={j}>{val}</TD>
          )
        )}
      </TR>
    ))
  }

  const renderAccountHeadings = () =>{
          let heads = [
      'Account Code',
      'Account Name',
      'Segment',
     ]
       let individualHeads = ['On Target Payout (Default)',
      'Individual OverAll Weighted % for MTD',
      'Individual OverAll Weighted % for QTD',
      'Individual OverAll Weighted % for YTD',
      'Individual Final Payout Amount',
      'Individual Final Payout %']

  individualHeads = !!queryFilters.selectedSipSegment && queryFilters.selectedSipSegment.value === 184 ? 
  individualHeads.filter(el => el !=='Individual OverAll Weighted % for YTD') : queryFilters.selectedSipSegment && (queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 358) ?
  individualHeads.filter(el => el !=='Individual OverAll Weighted % for MTD') : individualHeads

let KpiCodes = !!sipWidgetAccountDetails && !!sipWidgetAccountDetails[0] && !!sipWidgetAccountDetails[0].header ? sipWidgetAccountDetails[0].header : []

let filteredKpiCodes = Object.entries(KpiCodes)?.map((header, i) => {
    const [key, value]  = header
    let removeHeads = Object.entries(value).filter(([key]) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','widget_type_name','widget_type_code_sequence_id', 'customer_account_code','customer_account_name'].includes(key))
  return Object.fromEntries(removeHeads)
    })  
  let subHeads = []
  let isParentKpi = false
  let toolTipName = ''
  let dynamicHeads = !!KpiCodes && 
  Object.entries(KpiCodes).map((header, i) => {
        const [key, value]  = header
        isParentKpi = value['is_parent_kpi']
        toolTipName = value['widget_type_name'] || 'NA'
        subHeads = Object.entries(value).filter(([key]) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','is_parent_kpi','widget_type_name','widget_type_code_sequence_id','customer_account_code','customer_account_name'].includes(key))
        return (
        <TH rowSpan={1} classes={isParentKpi ? `parent-column-Theme`: `green-theme`} justify={"center"} colSpan={subHeads.length} key={i + 1}>
           <Tooltip
                  label={toolTipName}
                  fontSize="sm"
                  bg="secondary"
                  color="black.700"
                ><span> {value.widget_type_measurement_unit !== 'INR' ? `${key} ( ${value.widget_type_measurement_unit}; Value In - ${value.widget_type_measurement_name} )` : `${key} (Value In - ${value.widget_type_measurement_name})`}
        </span>
        </Tooltip>
        </TH>
      )
    })
   
    heads = heads.map(item => (
      <TH rowSpan={2} key={item}>
        {item}
      </TH>
    ))
    individualHeads = individualHeads.map(item => (
      <TH rowSpan={2} key={item}>
        {item}
      </TH>
    ))
    heads = heads.concat(dynamicHeads)
   heads = heads.concat(individualHeads)
    let tableHead = (
      <>
        <TR>
          <TH rowSpan={2}>#</TH>
          {heads}
        </TR>
        <TR>
        {!!dynamicHeads && dynamicHeads.length>0 &&
           filteredKpiCodes?.map((kpi) => (
            Object.values(kpi).filter(el=> el!== 0 && el!== 1).map((key,i) =>
              <TH rowSpan={1} classes={kpi['is_parent_kpi'] === 1 ? `parent-column-Theme` : `green-theme`} key={key}>
                {key}
              </TH>
            )))
          }
        </TR>
      </>
    )
    return tableHead
      }

  const makeSelfDynamicData = () => {
    let obj = {}
    let managerKpiData = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0]?.body ? sipWidgetManagerTargetList[0].body : []
    let data = Object.values(managerKpiData)
    let filteredPrediction = []
    data.map((item)=>{
      delete item.widget_type_measurement_name
      delete item.widget_type_measurement_unit
      Object.entries(item).map(([key, value]) => {
        let keyName = item['widget_type_name'] +'_' + getColumnHeader(item['widget_type_code'], key, true)
        if(key !== 'widget_type_code' && key !== 'asset_id' && key !== 'employee_email_id' && key !== 'is_parent_kpi' && key !== 'widget_type_name' && key !== 'widget_type_code_sequence_id') 
      filteredPrediction.push({[keyName]:  value}) 
      })
      return filteredPrediction
    })
    obj = !!filteredPrediction && filteredPrediction.length>0 ? Object.assign(...filteredPrediction) : {}
   
    return obj
  }
   const makeAccountData =() =>{
      let data = []
      let _arr = !!sipWidgetAccountDetails && !!sipWidgetAccountDetails[0]?.accountCodes ? sipWidgetAccountDetails[0].accountCodes : []
      let accountKpiHeaders = !!sipWidgetAccountDetails && !!sipWidgetAccountDetails[0]?.header ? sipWidgetAccountDetails[0].header : []
      let accountsSubHeadData = setAccountKpiResponseBody()
  
      let parentHead = Object.values(accountsSubHeadData)
      _arr?.forEach((item, i) => {
        let obj = {}
        obj['s.no'] = i + 1
        obj['Account Code'] = item.customer_account_code
        obj['Account Name'] = item.customer_account_name
        
        obj['Segment'] =  item.workforce_tag_name || '-'
        
        let kpiCodeHead = !!parentHead && parentHead.length>0  ? 
        parentHead?.filter(el =>  item.customer_account_code === el.customer_account_code)
        : []
        if(!!accountKpiHeaders && Object.entries(accountKpiHeaders).length > 0){
        let accountKpiData = !!accountsSubHeadData.get(item.customer_account_code+ "::" + item.workforce_tag_name) ? Array.from(accountsSubHeadData.get(item.customer_account_code+ "::" + item.workforce_tag_name)) : []
        
         
          let accountPredictionValues = !!accountKpiData && accountKpiData.length > 0 ? Object.assign(...accountKpiData) : {}
          obj =  {...obj, ...accountPredictionValues}
        }
        obj['On Target Payout (Default)']= (!!item.payout_target && item.payout_target.toFixed(2)) || 0
        if(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 0)){
        obj['Individual OverAll Weighted % for MTD']= (!!item.overall_ach_mtd && item.overall_ach_mtd.toFixed(2) + ' %') || '0.00 %'
        }
        obj['Individual OverAll Weighted % for QTD']= (!!item.overall_ach_qtd && item.overall_ach_qtd.toFixed(2) + ' %') || '0.00 %'
        if(!!queryFilters && (queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0 || queryFilters.selectedSipSegment.value === 358)){
        obj['Individual OverAll Weighted % for YTD']= (!!item.overall_ach_ytd && item.overall_ach_ytd.toFixed(2) + ' %') || '0.00 %'
        }
        obj['Individual Final Payout Amount']= (!!item.final_payout_amount && item.final_payout_amount.toFixed(2)) || 0
        obj['Individual Final Payout %']= (!!item.final_payout_percentage && item.final_payout_percentage.toFixed(2) + ' %') || '0.00 %'
  
        if (isAccountManager) {
          ;[9, 10, 11, 12, 13, 14].forEach(x => {
            obj[x] = '-'
          })
        }
  
        data.push(obj)
      })
      return [data, _arr]
    }

  const makeSelfData = () => {
    let data = []
    
    let _arr = managerDetails || []
    let managerKpiHeaders = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0]?.header ? sipWidgetManagerTargetList[0].header : []
    let managersSubHeadData = !!managerKpiHeaders && Object.entries(managerKpiHeaders).length > 0 ? setManagerKpiResponseBody() : []
    let parentHead = Object.values(managersSubHeadData)
    _arr?.forEach((item, i) => {
      let obj = {}
      if(!!item.operating_asset_first_name){
      obj['s.no'] = i + 1
      obj['Employee Name'] = item.operating_asset_first_name
      obj['Employee Code'] = item.operating_asset_customer_unique_id
      obj['Employee Email'] = !isAccountManager
        ? item.operating_asset_email_id
        : '-'
      obj['Role'] = !isAccountManager ? item.asset_type_name : '-'
      obj['Segment'] = !isAccountManager ? item.workforce_tag_name : '-'
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0)){
      obj['Circle'] = !isAccountManager ? item.account_name : '-'
      obj['Cluster'] = !isAccountManager ? item.cluster_tag_name : '-'
      }
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 358 || queryFilters.selectedSipSegment.value === 0)){
      obj['Vertical'] = !isAccountManager ? item.asset_vertical_name : '-'
      }
      if(!!managerKpiHeaders && Object.entries(managerKpiHeaders).length > 0){
      obj['Employees on SIP']= !!item.employees_on_sip ? item.employees_on_sip : '1'
      obj['Qualified for SIP']= !!item.qualified_for_sip ? item.qualified_for_sip : '1'
      obj['Summarized SIP Penetration %']= !!item.asset_flag_frontline && item.asset_flag_frontline !== 1 && !!item.percentage_penetration ? item.percentage_penetration.toFixed(2) + '%' : '-'
      obj['Summarized SIP Utilization %']=  !!item.asset_flag_frontline && item.asset_flag_frontline !== 1 && !!item.summary_utilization ? item.summary_utilization.toFixed(2) + '%' : '-'
      if(!!queryFilters && queryFilters.selectedPeriodType.value === 'QTD'){
      obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_qtd ? item.summary_weighted_sip_target_vs_achievement_qtd.toFixed(2) + ' %' :'-'
      }
      else if(!!queryFilters && queryFilters.selectedPeriodType.value === 'MTD'){
        obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_mtd ? item.summary_weighted_sip_target_vs_achievement_mtd.toFixed(2) + ' %' :'-'
      }
      else if(!!queryFilters && queryFilters.selectedPeriodType.value === 'YTD'){
        obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_ytd ? item.summary_weighted_sip_target_vs_achievement_ytd.toFixed(2) + ' %' :'-'
      }
      else{
        obj[`Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`]= !!item.summary_weighted_sip_target_vs_achievement_ytd ? item.summary_weighted_sip_target_vs_achievement_ytd.toFixed(2) + ' %' :'-'
      }
     
      let kpiCodeHead = !!parentHead && parentHead.length>0  ? 
      parentHead?.filter(el =>  item.asset_id === el.asset_id)
      : []

      let managerKpiData = !!managersSubHeadData.get(item.asset_id + "::" + item.workforce_tag_id) ? Array.from(managersSubHeadData.get(item.asset_id + "::" + item.workforce_tag_id)) : []
      
       
        let managerPredictionValues = !!managerKpiData && managerKpiData.length > 0 ? Object.assign(...managerKpiData) : {}
      obj =  {...obj, ...managerPredictionValues}
       
      obj['On Target Payout (Default)']= (!!item.payout_target && item.payout_target.toFixed(2)) || 0
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 0)){
      obj['Individual OverAll Weighted % for MTD']= (!!item.overall_ach_mtd && item.overall_ach_mtd.toFixed(2) + ' %') || '0.00 %'
      }
      obj['Individual OverAll Weighted % for QTD']= (!!item.overall_ach_qtd && item.overall_ach_qtd.toFixed(2) + ' %') || '0.00 %'
      if(!!queryFilters && (queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0 || queryFilters.selectedSipSegment.value === 358)){
      obj['Individual OverAll Weighted % for YTD']= (!!item.overall_ach_ytd && item.overall_ach_ytd.toFixed(2) + ' %') || '0.00 %'
      }
      obj['Individual Final Payout Amount']= (!!item.final_payout_amount && item.final_payout_amount.toFixed(2)) || 0
      obj['Individual Final Payout %']= (!!item.final_payout_percentage && item.final_payout_percentage.toFixed(2) + ' %') || '0.00 %'

    }
  }
      if (isAccountManager) {
        ;[9, 10, 11, 12, 13, 14].forEach(x => {
          obj[x] = '-'
        })
      }

      data.push(obj)
    })
    return [data, _arr]
  }

 const renderSelfData = () => {
   let [data, _arr] = makeSelfData()
   return !!data && data.map((item, i) => (
    <TR key={i} >
      {Object.values(item).map((val, j) =>
        j === 1 ? (
          <TD
            key={j}
            classes={`text-bold green-theme cursor-pointer`}
          >
            {val}
          </TD>
        ) : (
          <TD key={j}>{val}</TD>
        )
      )}
    </TR>
  ))
  }

  const handleDownload = () => {
    setDownload(true)
  }

  const exportHeadings = self => {
    let heads = [
      self
        ? 'Self'
        : isAccountManager
        ? 'Account/Channel Name'
        : 'Employee Name',
      isAccountManager ? 'Account/Channel Code' : 'Employee Code',
      'Employee Email',
      'Role',
      'Segment',
      ...(!!queryFilters && (queryFilters.selectedSipSegment.value === 184 || queryFilters.selectedSipSegment.value === 185 || queryFilters.selectedSipSegment.value === 0) ? [
        'Circle','Cluster'
        ] : []),
        ...(!!queryFilters && (queryFilters.selectedSipSegment.value === 358 || queryFilters.selectedSipSegment.value === 0) ? [
          'Vertical'
          ] : []),
      'Employees on SIP',
      'Qualified for SIP',
      'Summarized SIP Penetration %',
      'Summarized SIP Utilization %',
      `Weighted SIP Target vs Acheivement % (${ !!queryFilters && queryFilters.selectedPeriodType.label})`
        ]

    let individualHeads =['On Target Payout (Default)',
 'Individual OverAll Weighted % for MTD',
  'Individual OverAll Weighted % for QTD',
  'Individual OverAll Weighted % for YTD',
'Individual Final Payout Amount',
'Individual Final Payout %']
    let KpiCodes
    if(self){
      KpiCodes = !!sipWidgetManagerTargetList && !!sipWidgetManagerTargetList[0] && !!sipWidgetManagerTargetList[0].header ? sipWidgetManagerTargetList[0].header : []
    }
    else {
      KpiCodes = !!sipWidgetList && !!sipWidgetList[0] && !!sipWidgetList[0].header ? sipWidgetList[0].header : []
    }
    let subHeads = []
   
   let dynamicHeads = Object.entries(KpiCodes).map((header, i) => {
      // let unit,
      //   format = ''
      const [key, value]  = header
      subHeads = Object.entries(value).filter(([key]) => !['widget_type_code','widget_type_measurement_name','widget_type_measurement_unit', 'asset_id' , 'employee_email_id','is_parent_kpi','widget_type_name','widget_type_code_sequence_id'].includes(key))
     return Object.values(subHeads).map(
        sub => `${value['widget_type_name']}_${sub[1]}`
      )
        
    })

    heads = heads.concat(_.flattenDeep(dynamicHeads))
    heads = heads.concat(individualHeads)
    return heads
  }

  const renderExportData = () => {
    let [dataSet] = makeTableData()
    let selfData = makeSelfData()
    const fileName = 'SIP_Download'
    return (
      <ExcelFile filename={fileName} hideElement={true} >
        {[
          { sheet: 'SIP Data', data: dataSet, heads: exportHeadings() },
          { sheet: 'Self Data', data: selfData , heads: exportHeadings(true) },
        ].map(item => (
          <ExcelSheet data={item.data} name={item.sheet}>
            {item.heads?.map(headerItem => (
              <ExcelColumn label={headerItem}  value={headerItem}  />
            ))}
          </ExcelSheet>
        ))}
      </ExcelFile>
    )
  }

  const widgetMainView =
  isReporteesLoading || isChannelLoading || isManagerLoading || isReporteesSipKpiLoading || isManagerSipKpiLoading ? (
      <Stack>
        <Skeleton height="20px" />
        <Skeleton height="20px" />
        <Skeleton height="20px" />
      </Stack>
    ) : (
      <Box>
        <Flex mb={3} p={3} alignItems="center">
          <Icon
            as={BiDownload}
            w={6}
            h={6}
            onClick={() => {
              sectionDetailedTrack({
                category: GA_CATEGORY_DASHBOARD,
                action: 'Widget SIP View',
                label: 'Download',
              })
              handleDownload()
            }}
            className={`cursor-pointer`}
          />
          &nbsp;&nbsp;
          {download && renderExportData()}
          {!isAccountManager &&
            !!sipReporteeList &&
            sipReporteeList.map((item, i) => (
              <>
                {i !== 0 ? '/' : null}
                <Text
                  fontWeight="bold"
                  onClick={() => {
                    sectionDetailedTrack({
                      category: GA_CATEGORY_DASHBOARD,
                      action: 'Widget SIP View',
                      label: 'Load Resource For Asset',
                    })
                    dashboardDispatch({
                      type:dashboardConst.ADD_ACTIVE_FILTER_OPTION,
                      activeFilterOption:item
                    })
                    loadResourceForAsset(item)
                  }}
                  color="green.600"
                  cursor="pointer"
                  textDecoration="underline"
                >
                  {' '}
                  {item.operating_asset_first_name}{' '}
                </Text>
              </>
            ))}
        </Flex>
        {isManagerSuccess &&  isReporteesSuccess && isReporteesSipKpiSuccess && isManagerSipKpiSuccess ? (
          <VStack spacing={8}>
            { managerDetails?.length && !!managerDetails[0]?.operating_asset_first_name ? (
              <>
                <DrillDownTable
                  theadings={renderSelfHeadings(true)}
                  tdata={renderSelfData()}
                />
                <Divider />
              </>
            ) : null}
             { !!managerDetails[0]?.asset_flag_frontline && managerDetails[0]?.asset_flag_frontline === 1 ?
                (<DrillDownTable theadings={renderAccountHeadings()} tdata={renderAccountData()}  />)
                : null
              }
            {reporteeList?.length > 0 && !!reporteeList[0].operating_asset_first_name  ? 
            (<DrillDownTable theadings={renderHeadings()} tdata={renderData()} />) 
            : null
            }
          </VStack>
        ) : null}
      </Box>
    )

  return (
    <Box bg="white" rounded="md" p="8px">
      {widgetMainView}
    </Box>

  )
}

export default WidgetSIPDynamic2View
